<script>
  import { onMount } from "svelte";
  import Conexoes from "./../Classes/Conexoes.js";
  import Constantes from "./../Classes/Constantes.js";
  import LoadingTela from "../componentes_basicos/LoadingTela.svelte";
  import CaixaDeDialogo from "../componentes_basicos/CaixaDeDialogo.svelte";
  import { Paper } from "@svelteuidev/core";
  import DropDownDb from "../componentes_basicos/DropDownDB.svelte";
  let isLoading = false;
  let conexao = new Conexoes();

  let prova = 0;
  let quantBaterias = 0;
  let quantRaias = 6;
  let horasInicio = "08:00";
  let tempoBateria = 12;
  let intervaloBateria = 2;
  let message;
  let teams = [];
  let results = [];
  let showModal = false;
  let duplicatedEntries = [];

  let showConfirmaGeraBateria = false;
  let id_inscricao;
  function handleButtonClick() {
    console.log(results.length);
    if (results.length > 0) {
      showConfirmaGeraBateria = true;
    }
  }

  async function carregaBaterias() {
    isLoading = true;
    try {
      teams = await conexao.conecta(Constantes.api_consultar_padrao, {
        query_code: "consulta_baterias_raias_prova",
        id_prova: prova,
      });
      results = teams.map((team) => ({
        id_inscricao: team.id,
        name: team.atletas,
        box: team.box,
        categoria: team.categoria,
        equipe: team.equipe,
        sigla: team.sigla,
        prova: team.id_prova,
        bateria: team.bateria || 1,
        raia: team.raia || 1,
        horario: team.horario || "",
        cor: false,
      }));
    
      console.log("teams",teams);
      if (!teams || teams.length < 1) {
        teams = await conexao.conecta(Constantes.api_consultar_padrao, {
          query_code:
            Constantes.query_code_consulta_generica_livre_sem_coluna_deletado,
          tabela: "baterias_raias_view",
        });
        results = teams.map((team) => ({
          id_inscricao: team.id,
          name: team.atletas,
          box: team.box,
          categoria: team.categoria,
          equipe: team.equipe,
          sigla: team.sigla,
          prova: team.id_prova,
          bateria: 1,
          raia: 1,
          horario: "",
          cor: false,
        }));
      }
      
    } catch (error) {
      console.error("Erro ao carregar os dados:", error);
    }
    isLoading = false;
  }

  function gerarBaterias() {
    results = geraBat(results, quantRaias);
    verificarDuplicados();
    calcularHorarios();
    showConfirmaGeraBateria = false;
  }

  function cancelAction() {
    showConfirmaGeraBateria = false;
  }

  function geraBat(teams, quantRaias) {
    let bateria = 1;
    let raia = 1;
    let siglaAtual = teams[0].sigla;
    quantBaterias = 0;

    teams.forEach((team, index) => {
      if (team.sigla !== siglaAtual) {
        siglaAtual = team.sigla;
        bateria = 1;
        raia = 1;
        quantBaterias++;
      }

      team.bateria = bateria;
      team.raia = raia;

      raia++;
      if (raia > quantRaias) {
        raia = 1;
        bateria++;
        quantBaterias++;
      }
    });

    return teams;
  }

  async function Salvar() {
    console.log(results);
    isLoading = true;
    let parametros = {};
    parametros["body"] = results;
    if (!verificarDuplicados()) {
      let resultado = await conexao.conecta(
        "inserir_baterias.php",
        parametros,
       
      );
      if (resultado && resultado.sucesso){
        message=Constantes.msg_inserido_sucesso;
      }else{
         message=Constantes.msg_erro_conexao_bd;
      }
    }
    isLoading = false;
  }
  function verificarDuplicados() {
    const seen = new Set();
    duplicatedEntries = [];
    let saida = "";
    results.forEach((result) => {
      const key = `${result.sigla}-${result.bateria}-${result.raia}`;

      if (seen.has(key)) {
        //duplicatedEntries.push(result);
        saida +=
          " <li> " +
          result.sigla +
          " - Bateria: " +
          result.bateria +
          " - Raia: " +
          result.raia +
          "</li>";
      } else {
        seen.add(key);
      }
    });

    console.log("mensagem", message);
    if (saida) {
      saida =
        "<ul>" +
        " <h5>Verifique os seguintes casos Repetidos de Bateria x Raia</h5>" +
        saida +
        "</ul>";
      message = saida;
      showModal = true;
      return true;
    } else {
      return false;
    }
  }

  function fecharModal() {
    showModal = false;
  }

  function calcularHorarios() {
    const [horas, minutos] = horasInicio.split(":").map(Number);
    let inicio = new Date();
    inicio.setHours(horas);
    inicio.setMinutes(minutos);
    inicio.setSeconds(0);

    let lastSigla = "";
    let lastBateria = 0;
    let lastCor = true;
    let horaAnterior = "";

    results.forEach((result) => {
      if (result.sigla !== lastSigla || result.bateria !== lastBateria) {
        lastSigla = result.sigla;
        lastBateria = result.bateria;
        const horarioFormatado = inicio.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
        result.horario = horarioFormatado;
        horaAnterior = horarioFormatado;

        result.cor = lastCor;
        lastCor = !lastCor;

        inicio.setMinutes(
          inicio.getMinutes() + tempoBateria + intervaloBateria,
        );
      } else {
        result.horario = horaAnterior;
        result.cor = !lastCor;
      }
      result.prova = prova;
    });

    console.log(JSON.stringify(results, null, 2));
  }

  let config_campeonato = {
    api: Constantes.api_consultar_padrao,
    parametros: {
      query_code:
        Constantes.query_code_consulta_generica_livre_sem_coluna_deletado,
      tabela: "provas_campeonato_view",
    },
    nome_coluna_opcoes: "campeonato_prova",
    nome_coluna_saida: "id",
    filtravel: false,
    itens: "",
  };
 
</script>

<LoadingTela {isLoading} />
<CaixaDeDialogo {message} on:close={()=>message=""}/>
<div class="margem">
  <Paper>
    <div class="fonte">
      <strong>Cadastro de Baterias e Raias</strong>
    </div>

  
        <label for="prova">Selecione a prova:</label>
     
        <DropDownDb config={config_campeonato} bind:saida={prova} />
    
    

    <div class="linha fonte2">
      <div class="linha-col1">
        <label for="raias"
          >Selecione a quantidade de Raias disponíveis para essa Prova:</label
        >
      </div>
      <div class="linha-col2">
        <input
          class="fonte3"
          type="number"
          id="raias"
          bind:value={quantRaias}
          min="1"
          max="10"
          step="1"
        />
      </div>
      <div class="linha-col3"></div>
    </div>
    <div class="linha fonte2">
      <div class="linha-col1">
        <label for="horas">Horas para inicio da Prova (previsão):</label>
      </div>
      <div class="linha-col2">
        <input class="fonte3" type="time" id="horas" bind:value={horasInicio} />
      </div>
      <div class="linha-col3"></div>
    </div>
    <div class="linha fonte2">
      <div class="linha-col1">
        <label for="tempoBateria">Duração prevista de cada Bateria (min):</label
        >
      </div>
      <div class="linha-col2">
        <input
          class="fonte3"
          type="number"
          id="tempoBateria"
          bind:value={tempoBateria}
          min="1"
          max="40"
          step="1"
        />
      </div>
      <div class="linha-col3"></div>
    </div>
    <div class="linha fonte2">
      <div class="linha-col1">
        <label for="intervaloBateria"
          >Duração prevista de intervalo entre cada Bateria (min):</label
        >
      </div>
      <div class="linha-col2">
        <input
          class="fonte3"
          type="number"
          id="intervaloBateria"
          bind:value={intervaloBateria}
          min="0"
          max="40"
          step="1"
        />
      </div>
      <div class="linha-col3"></div>
    </div>

    <div class="buttons-container">
      <button class="buttonAzul" on:click={carregaBaterias}
        >Carregar Baterias</button
      >
      {#if results && results.length > 0}
        <button class="buttonVermelho" on:click={handleButtonClick}
          >Gerar Baterias Automaticamente</button
        >
        <button class="buttonVerde" on:click={Salvar}>Salvar</button>
      {/if}
    </div>
  </Paper>
  {#if results.length > 0}
    {#if quantBaterias > 0}
      <div class="bordaGeral">
        <div class="fonte4">
          Foram criadas automaticamente um total de {quantBaterias} Baterias.
        </div>
      </div>
      <br />
    {/if}

    <div style="display: flex; width: 100%;">
      <div class="cabecalho" style="width: 38%">Atleta(s)</div>
      <div class="cabecalho" style="width: 16%">Equipe</div>
      <div class="cabecalho" style="width: 13%">Box</div>
      <div class="cabecalho" style="width: 16%">Categoria</div>
      <div class="cabecalho" style="width: 5%">Bateria</div>
      <div class="cabecalho" style="width: 5%">Raia</div>
      <div class="cabecalho" style="width: 7%">Horário</div>
    </div>

    {#each results as result, index}
      <div
        style="display: flex; width: 100%;"
        class={result.cor
          ? "cor1 registroSelecionado"
          : "cor2 registroSelecionado"}
      >
        <div class="registro" style="width: 38%">{result.name}</div>
        <div class="registro" style="width: 16%">{result.equipe}</div>
        <div class="registro" style="width: 13%">{result.box}</div>
        <div class="registro" style="width: 16%">{result.categoria}</div>
        <div class="registro" style="width: 5%">
          <select
            style="color: #024c91; font-weight: bold; height: 25px;"
            bind:value={result.bateria}
          >
            {#each Array.from({ length: 10 }, (_, i) => i + 1) as bateriaValue}
              {#if bateriaValue == result.bateria}
                <option value={result.bateria}>{bateriaValue}</option>
              {:else}
                <option value={bateriaValue}>{bateriaValue}</option>
              {/if}
            {/each}
          </select>
        </div>
        <div class="registro" style="width: 5%">
          <select
            style="color: #024c91; font-weight: bold; height: 25px;"
            bind:value={result.raia}
          >
            {#each Array.from({ length: 10 }, (_, i) => i + 1) as raiaValue}
              {#if raiaValue == result.raia}
                <option value={result.raia}>{raiaValue}</option>
              {:else}
                <option value={raiaValue}>{raiaValue}</option>
              {/if}
            {/each}
          </select>
        </div>
        <div class="registro" style="width: 7%">{result.horario}</div>
      </div>
    {/each}

    {#if showModal}
      <!--<div class="modal">
        <div class="modal-content">
          <span class="close" on:click={fecharModal}>&times;</span>
          <h5>Verifique os seguintes casos Repetidos de Bateria x Raia</h5>
          <ul>
            {#each duplicatedEntries as entry}
              <li>
                {entry.sigla} - Bateria: {entry.bateria} - Raia: {entry.raia}
              </li>
            {/each}
          </ul>
        </div>
      </div>
      -->
      {message}
      <CaixaDeDialogo {message} on:close={fecharModal} />
    {/if}

    {#if showConfirmaGeraBateria}
      <div class="modal show">
        <div class="modal-content">
          <p><strong>GERAR BATERIAS AUTOMATICAMENTE</strong></p>
          <p>Tem certeza que deseja executar esta ação?</p>
          <button class="buttonVerde" on:click={gerarBaterias}>Confirmar</button
          >
          <br />
          <button class="buttonVermelho" on:click={cancelAction}
            >Cancelar</button
          >
        </div>
      </div>
    {/if}
  {/if}
</div>

<style>
  .cabecalho {
    text-align: center;
    /*border: 2px solid #4bb8f3; /* Define a borda com 2px de largura e cor preta */
    /*border-radius: 5px; /* Define o arredondamento dos cantos */
    background: #d3f3ff;
    padding: 5px; /* Adiciona um preenchimento interno à div */
    font-size: 15px;
    font-weight: bold;
    margin: 0px;
  }

  .registro {
    text-align: left;
    border: 1px solid #e4f7fb; /* Define a borda com 2px de largura e cor preta */
    border-radius: 0px; /* Define o arredondamento dos cantos */
    /*background: #ffffff;*/
    padding: 5px; /* Adiciona um preenchimento interno à div */
    font-size: 12px;
    color: #024c91;
    font-weight: bold;
    margin: 0px;
  }

  .registroSelecionado:hover {
    background-color: rgb(189, 210, 217);
  }

  .cor1 {
    background-color: #e9f3fa;
  }
  .cor2 {
    background-color: #ffffff;
  }

  .bordaGeral {
    border: 2px solid #dedede;
    border-radius: 5px;
    background: #cbd4fd;
    padding: 5px;
    font-size: 13px;
    font-weight: bold;
    display: flex;
    flex-direction: column;
    align-items: center; /* Centraliza itens horizontalmente */
  }
  .modal {
    display: block;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0, 0, 0);
    background-color: rgba(0, 0, 0, 0.4);
  }

  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 40%;
  }

  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  button {
    font-family: "Roboto", sans-serif;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    color: white;
    cursor: pointer;
    transition: background-color 0.3s;
  }

  .buttonAzul {
    background-color: #1976d2;
  }

  .buttonVermelho {
    background-color: #ee7171;
  }

  .buttonVerde {
    background-color: #67ca7b;
  }

  .margem {
    margin-top: 70px;
    margin-left: 20px;
    margin-right: 20px;
    margin-bottom: 100px;
  }

  select {
    width: 100%;
  }
  @media screen and (min-width: 1800px) {
    table {
      max-width: 1800px;
    }
  }

  .fonte {
    font-size: 30px;
    font-weight: bold;
    color: #000080;
    text-align: center;
  }

  .fonte2 {
    font-size: 16px;
    font-weight: bold;
  }

  .fonte3 {
    font-size: 18px;
    font-weight: bold;
    color: #000080;
    text-align: right;
    width: 90px;
  }

  .fonte4 {
    font-size: 18px;
    font-weight: bold;
    color: #4c4cbf;
    text-align: center;
  }

  input {
    border: 3px solid #000080;
    border-radius: 4px;
  }

  .buttons-container {
    display: flex;
    gap: 30px; /* Espaçamento entre os botões */
    margin: 10px; /* Espaçamento entre o label e os botões */
  }

  .linha {
    display: flex;
    width: 100%;
  }

  .linha-col1,
  .linha-col2,
  .linha-col3 {
    display: flex;
    height: 100%;
  }

  .linha-col1 {
    width: 33%;
  }

  .linha-col2 {
    width: 15%;
  }

  .linha-col3 {
    width: 52%;
  }
</style>
